// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/goods-action/index.css
// module id = 1772
// module chunks = 148